module.exports = __webpack_public_path__ + "static/media/exam-details-header.4d21a735.jpg";